module.exports = __webpack_public_path__ + "img/01_Winzer_Foto_2022.443bc071.jpg";